//License
const React = require('react');
const { LicenseInfo } = require('@mui/x-license');
const moment = require('moment');
const ReactDOM = require('react-dom/client');
const log = require('@gral/log')('STARTUP');
const App = require('@gral/app').default;
const { getApplicationName } = require('@gral/config.js');

// First-time inits
App.appName = getApplicationName();

// i10n (not implemented yet)
moment.locale('en-GB');

module.exports = function (appConfig) {
  // Init log policy
  overrideConsole();

  // For the time being...
  log.info(`${App.mode.toUpperCase()} mode`);
  // Promise.longStackTraces()
  log.info('Starting!');

  // Initialise routes
  /*   if (appConfig.routes && appConfig.routes.init) {

    appConfig.routes.init();
  } */

  // Initialise server interface
  //const server = require('@flux/actions/server');
  //server.init();

  // Create stores
  /* const routeStore = require('@flux/stores/routeStore');
  routeStore.configRoutes(appConfig.routes);
  require('@flux/stores/centralStore'); */

  // Process current URL
  /*   const router = require('@flux/actions/router');
  router.config(appConfig.routes);
  router.start();
 */

  // Create root component
  const RootComponent = appConfig.getRootComponent();
  // Initiate root component
  window.onload = function () {
    const rootElement = document.querySelector('#root');
    LicenseInfo.setLicenseKey('17f9e0234e072bbf95179d81a03b150fTz0xMDk4NzIsRT0xNzc0MTM3NTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=');

    ReactDOM.createRoot(rootElement).render(<RootComponent />);
  };

  //return ReactDOM.render(<RootComponent />, document.getElementById('root'));
};

/*
 * This function overrides the console methods to avoid logging in production,
 * specially due to the MQTT library which logs a lot of stuff even
 * defining the DEBUG env variable with '*,-mqtt*'.
 */
function overrideConsole() {
  if (App.mode === 'production') {
    console.debug = function () { };
    console.log = function () { };
    console.info = function () { };
    console.warn = function () { };
    console.error = function () { };
  }
}
